// src/pages/AuditLog.jsx
import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

export default function AuditLog() {
  const [entries, setEntries] = useState([]);
  const [error, setError] = useState('');
  const [filters, setFilters] = useState({ caseRef: '', action: '' });

  async function load() {
    try {
      const params = new URLSearchParams();
      if (filters.caseRef) params.set('caseRef', filters.caseRef);
      if (filters.action) params.set('action', filters.action);
      const body = await api(`/admin/audit-log?${params.toString()}`);
      setEntries(body.entries);
    } catch (err) {
      setError(err.message);
    }
  }

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-xl font-semibold text-charcoal">Audit Logs</h1>
      <p className="text-xs text-ink/50 mt-1">Every sensitive action — logins, case status changes, transcript views, staff/role edits — is recorded here.</p>

      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="mt-4 flex gap-2">
        <input
          value={filters.caseRef} onChange={(e) => setFilters({ ...filters, caseRef: e.target.value })}
          placeholder="Filter by case ref (e.g. SAU-2026-0001)"
          className="rounded-md border border-ink/20 px-3 py-1.5 text-xs font-mono"
        />
        <input
          value={filters.action} onChange={(e) => setFilters({ ...filters, action: e.target.value })}
          placeholder="Filter by action contains…"
          className="rounded-md border border-ink/20 px-3 py-1.5 text-xs"
        />
        <button type="submit" className="text-xs rounded-md bg-ink text-white px-3 py-1.5">Filter</button>
      </form>

      {error && <p className="mt-3 text-sm text-p1">{error}</p>}

      <div className="mt-4 rounded-lg border border-ink/10 bg-white overflow-hidden">
        <table className="w-full text-xs">
          <thead className="bg-ink/5 text-left uppercase tracking-wide text-ink/50">
            <tr>
              <th className="px-3 py-2">Time</th>
              <th className="px-3 py-2">Actor</th>
              <th className="px-3 py-2">Action</th>
              <th className="px-3 py-2">Case</th>
              <th className="px-3 py-2">IP</th>
            </tr>
          </thead>
          <tbody>
            {entries.length === 0 && (
              <tr><td colSpan={5} className="px-3 py-4 text-center text-ink/40">No matching entries.</td></tr>
            )}
            {entries.map((e) => (
              <tr key={e.id} className="border-t border-ink/5">
                <td className="px-3 py-2 font-mono whitespace-nowrap">{new Date(e.created_at).toLocaleString()}</td>
                <td className="px-3 py-2">{e.actor_name} <span className="text-ink/40">({e.actor_type})</span></td>
                <td className="px-3 py-2 font-mono">{e.action}</td>
                <td className="px-3 py-2 font-mono">{e.case_ref ?? '—'}</td>
                <td className="px-3 py-2 font-mono text-ink/50">{e.ip_address ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
